/*
*
* File JS componente List Charter
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './list-charter.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const listCharter = () => {

    const context = document.querySelector('.list-charter');
    if(!context) return;
    const loadMore = context.querySelector('#load-more');
    const loader = document.querySelector('#loader');
    if(!loadMore) return;
    
    loadMore.addEventListener('click', (e) => {
        e.preventDefault();

        const mainFilter = document.querySelector('#charter-filter');
        if(!mainFilter) return;
        
        const filterValues = window.IM_GLOBAL.getFiltersWithinWrapper(mainFilter);  
        const mappedValues = window.IM_GLOBAL.mappingValues(filterValues, window.IM_GLOBAL.filterOperators);
        const page = e.target.dataset.page;
        fetchApi(mappedValues, page);
    });


    // Chiamata API
    function fetchApi(filterValues, page)
    {           
        loader.classList.add('active');
        const list = document.querySelector(`.list-charter__wrapper`);

        if(!loadMore || !list) return;

        // console.log(JSON.stringify(filterValues));

        fetch(`/wp-json/immedia-api/v1/charter/${page}?output=html`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(filterValues),
        })
        .then(response => response.json())
        .then(data => {
            const htmlContent = data['items'].join('');
            list.insertAdjacentHTML('beforeend', htmlContent);
            // list.innerHTML = htmlContent;            
            
            const showLoadMore = data['load_more'] ?? false;
            if (!showLoadMore) {
                loadMore.setAttribute('disabled', 'true');
            }

            loadMore.dataset.page = parseInt(page) + 1;
            loader.classList.remove('active');
        })
        .catch(error => {
            list.innerHTML = '<h2 class="h2">No results found</h2>' ;
            console.error('No results found', error);
            loader.classList.remove('active');
        });
    }
    
}


export default listCharter;

//--------------------------------------------------------------------//